<script setup lang="ts">
  import { onMounted, onUnmounted, ref } from 'vue';
  import { saveAs } from 'file-saver';
  import SimpleScrollableModal from './base/SimpleScrollableModal.vue';

  const props = defineProps<{
    blob: Blob;
    filename: string;
  }>();

  const emit = defineEmits<{
    (e: 'close'): void;
  }>();

  const blobUrl = ref<string | null>(null);

  onMounted(() => {
    blobUrl.value = URL.createObjectURL(props.blob);
  });

  onUnmounted(() => {
    if (blobUrl.value) URL.revokeObjectURL(blobUrl.value);
  });

  function download() {
    saveAs(props.blob, props.filename);
  }

  function close() {
    emit('close');
  }
</script>

<template>
  <simple-scrollable-modal>
    <template #title>
      <h3>Factura</h3>
    </template>
    <template #content>
      <div class="invoice-pdf-preview">
        <iframe
          v-if="blobUrl"
          :src="blobUrl"
          class="preview-frame"
          title="Vista previa de la factura"
        />
      </div>
    </template>
    <template #action-bar>
      <div class="invoice-pdf-preview-actions">
        <v-btn text @click="close">Cerrar</v-btn>
        <v-spacer />
        <v-btn color="primary" depressed @click="download">
          <v-icon left>mdi-file-download-outline</v-icon>
          Descargar
        </v-btn>
      </div>
    </template>
  </simple-scrollable-modal>
</template>

<style scoped lang="scss">
  .invoice-pdf-preview {
    @apply tw-w-full;

    .preview-frame {
      @apply tw-w-full tw-border-0 tw-rounded tw-bg-gray-100;
      height: 70vh;
    }
  }

  .invoice-pdf-preview-actions {
    @apply tw-flex tw-items-center tw-w-full;
  }
</style>
